<template>
    <div id="parameter-page">
        <ToolbarBackButtonComponent :title="$t('parameter_page.parameters')" class="mb-4" />

        <span class="text-uppercase ml-4 font-weight-bold">{{ $t('parameter_page.account_parameters') }}</span>
        <v-list class="pa-0 mb-6" color="background">
            <v-list-item-group>
                <v-list-item :to="'/parameter/manage_space'" data-cy="management-space" link>
                    <v-list-item-icon>
                        <v-icon>mdi-view-dashboard-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('parameter_page.space_information') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider class="mr-4 ml-4" color="white" />

                <v-list-item :to="'/parameter/management_user'" data-cy="management-user" link>
                    <v-list-item-icon>
                        <v-icon>mdi-account-group</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('parameter_page.user_management') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider class="mr-4 ml-4" color="white" />

                <v-list-item :to="'/parameter/customisation'" link>
                    <v-list-item-icon>
                        <v-icon>mdi-view-dashboard-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('parameter_page.personalization') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>

        <span class="text-uppercase ml-4 font-weight-bold">{{ $t('parameter_page.platform_reviews') }}</span>

        <v-list class="pa-0 mb-6" color="background">
            <v-list-item-group>
                <v-list-item :inactive="isBtoCClient" :ripple="!isBtoCClient" @click="openSendCommentDialog()">
                    <v-list-item-icon>
                        <v-icon>mdi-comment-eye-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            <template v-if="isBtoCClient">
                                {{ $t('parameter_page.send_comment_fullup') }}
                                <span class="primary--text">{{ bToCCommentMail }}</span>
                            </template>
                            <template v-else>{{ $t('parameter_page.send_comment') }}</template>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>

        <span class="text-uppercase ml-4 font-weight-bold">{{ $t('parameter_page.general_conditions') }}</span>

        <v-list class="pa-0 mb-4" color="background">
            <v-list-item-group>
                <v-list-item :href="getLegalUrls().privacy" target="_blank">
                    <v-list-item-icon>
                        <v-icon>mdi-lock-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('parameter_page.privacy_policy') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider class="mr-4 ml-4" color="white" />

                <v-list-item :href="getLegalUrls().terms_and_conditions" target="_blank">
                    <v-list-item-icon>
                        <v-icon>mdi-text-box-check-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('parameter_page.terms_conditions_use') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>
        <p class="display-version version-parameter ml-3 mb-2">{{ $t('parameter_page.version') }} {{ app_version }}</p>

        <SendCommentDialogComponent ref="sendCommentDialog" />
    </div>
</template>

<script>
import ToolbarBackButtonComponent from '@/components/global/ToolbarBackButtonComponent'
import SendCommentDialogComponent from '@/components/comment/SendCommentDialogComponent.vue'

export default {
    name: 'ParameterPage',
    components: { SendCommentDialogComponent, ToolbarBackButtonComponent },
    data() {
        return {
            bToCCommentMail: 'migration@fullup.be',
        }
    },
    computed: {
        isBtoCClient() {
            return this.$store.getters['general/id_professional'] === 1766
        },
    },
    methods: {
        openSendCommentDialog() {
            if (this.isBtoCClient) {
                return
            }

            this.$refs.sendCommentDialog.openSendCommentDialog()
        },

        getLegalUrls() {
            if (window.location.hostname.toLowerCase().includes('fullup')) {
                return {
                    terms_and_conditions: 'https://fullup.io/en/terms-and-conditions/',
                    privacy: 'https://fullup.io/politique-de-confidentialite/',
                }
            }
            return {
                terms_and_conditions: 'https://fourdata.io/general-terms-and-conditions-of-sale/',
                privacy: 'https://fourdata.io/privacy/',
            }
        },
    },
}
</script>

<style>
.version-parameter {
    position: absolute;
    bottom: 5px;
    left: 5px;
}
</style>
